import { useCloseNavSearch } from "@hooks/use-nav-search-hooks";
import CloseButton from "@components/core/CloseButton";
import Button from "@components/core/Button";

function GroupLinksHeader({ blok, setOpenNavLinksSection }) {
  const closeNavSearch = useCloseNavSearch();

  return (
    <div className="group-links-header">
      <Button
        variant="ghost-dark"
        leftIconName="chevron-left"
        onClick={() => setOpenNavLinksSection(false)}
      />
      <p className="mb-0">{blok.title}</p>
      <CloseButton onClick={closeNavSearch} />
    </div>
  );
}

export default GroupLinksHeader;
